import React, {useEffect, useState} from "react";
import Dialog from '@material-ui/core/Dialog';
import t from '../../../helpers/t';
import {useSelector, paketinActions, externInvoicesActions} from "inbooma-api";
import {Biscuit} from "../../../../utils";
import { moment } from "../../../../../vendor";
import Loader from "../../../components/Loader";
import FileUpload from "../../../components/FileUpload";
import showNotification from "../../../helpers/showNotification";
import Preview from "./Preview";
import Button from "../../../components/Button";

const ShowUploadDialog = ({handleCloseDialog, dispatch, onFilterChanged, filter, setFilter,sort,
                              setSort,
                              currentUrl,
                              setNKey,
                              _readFile,
                              withActions,
                              setWithActions}) => {
    const _importCSV = useSelector(state => state.extern_invoices_data.importCSV);
    const [initialized,setInitialized] = useState(false);
    const [importCSVPending,setImportCSVPending] = useState(false);
    const [invoices,setInvoices] = useState(null);
    const [file, setFile] = useState('');
    const language = Biscuit.get('user.lang').replace('-','_');

    useEffect(() => {
        setInitialized(true);
    },[]);

    useEffect(() => {
        if (_importCSV.success === "" || importCSVPending === false) {
            return;
        }
        console.log(_importCSV,'_importCSV');
        if(_importCSV.success === true){
            let externInv = [];
            _importCSV?.data?.forEach(inv => {
                let externInvoiceRevisions;
                if (typeof inv.error === 'undefined') {
                    externInvoiceRevisions = inv.extern_invoices_revisions[0];
                    externInvoiceRevisions.externalClientId = inv.externalClientId;
                    externInvoiceRevisions.invoiceNbr = inv.invoiceNbr;
                    externInvoiceRevisions.system = inv.sys;
                } else {
                    externInvoiceRevisions = inv;
                }
                externInv.push(externInvoiceRevisions);
            });
            setInvoices(externInv);
        } else {
            setInvoices(_importCSV?.data);
        }
        setImportCSVPending(false);
    },[_importCSV]);

   const close = () =>{
       onFilterChanged(filter);
       handleCloseDialog();
   }

    const upload = (value) => {
           dispatch(externInvoicesActions.importCSV({
               token: Biscuit.get('token'),
               data: {csv_data: value},
               parameters: {
                   headers: {
                       'Accept-Language': language,
                       'Content-Language': language
                   }
               }
           }));
           setImportCSVPending(true);
    }

    return (
        <>
            {initialized &&
                <>
                    <Dialog
                        onClose={handleCloseDialog}
                        aria-labelledby="changelogs-dialog-title"
                        open={true}
                        name="changeLogsDialog"
                        id="multipleRecipientsDialog"
                        maxWidth={"md"}
                    >
                        <header className="inb-multiple-recipients-header">

                            <button
                                onClick={handleCloseDialog}
                                type="button"
                                id="inb-multiple-recipients-dialog-close-button"
                                className="button hollow secondary right button-close-multiple-recipients-dialog round"
                                title={t("close show upload")}
                            >
                                <i className="fi fi-x"></i>
                            </button>
                            <h4>{t('upload', null, 'capital')}</h4>

                            {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}

                        </header>
                        <div id="inb-c-main-multiple-recipients" className="inb-c-listing off-canvas-content"
                             data-off-canvas-content="">
                           <FileUpload
                               onChange={upload}
                               setFile={setFile}
                               file={file}
                               showInput={false}
                               addButtonDirection={'up'}
                               addButtonText={t('upload csv')}
                               />
                            <Preview
                                data={invoices}
                                dispatch={dispatch}
                                setFilter={setFilter}
                                filter={filter}
                                setNKey={setNKey}
                                sort={sort}
                                setSort={setSort}
                                currentUrl={currentUrl}
                                setWithActions={setWithActions}
                                withActions={withActions}
                                _readFile={_readFile}
                                />
                                <div className="inb-form-group-column medium-12" style={{marginTop:"20px",padding: "0px 1rem"}}>
                                    <span style={{textAlign:"center"}}>
                                        <Button
                                            url={"#"}
                                            eventHandler={close}
                                            label={"Schliessen"}
                                            icon={"fi fi-x"}
                                            id={'close'}
                                            />
                                    </span>
                                </div>
                        </div>
                    </Dialog>
                </>
            }
        </>
    );
};

export default ShowUploadDialog;
